const REPLY_COUNT_KEYS = [
  "total_replies",
  "totalReplies",
  "total_reply_count",
  "totalReplyCount",
  "total_replies_count",
  "totalRepliesCount",
  "replies_count",
  "repliesCount",
  "reply_count",
  "replyCount",
  "replies_received",
  "repliesReceived",
  "total_customer_replies",
  "totalCustomerReplies",
  "customer_replies",
  "customerReplies",
  "customer_replies_count",
  "customerRepliesCount",
  "conversations_count",
  "conversationsCount",
  "total_conversations",
  "totalConversations",
];

const readFirstDefined = (source, keys) => {
  if (!source) return null;
  const key = keys.find((item) => source[item] !== undefined && source[item] !== null);
  return key ? source[key] : null;
};

export const readAutomationFlowReplyCount = (flow) => {
  const directCount = readFirstDefined(flow, REPLY_COUNT_KEYS);
  if (directCount !== null) return directCount;

  const aggregate = readFirstDefined(flow, ["stats", "statistics", "metrics", "analytics", "summary"]);
  return readFirstDefined(aggregate, REPLY_COUNT_KEYS);
};
